/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCollateralResponse } from './ClaimCollateralResponse';
import {
    ClaimCollateralResponseFromJSON,
    ClaimCollateralResponseFromJSONTyped,
    ClaimCollateralResponseToJSON,
    ClaimCollateralResponseToJSONTyped,
} from './ClaimCollateralResponse';
import type { BalanceEntryResponse } from './BalanceEntryResponse';
import {
    BalanceEntryResponseFromJSON,
    BalanceEntryResponseFromJSONTyped,
    BalanceEntryResponseToJSON,
    BalanceEntryResponseToJSONTyped,
} from './BalanceEntryResponse';

/**
 * 
 * @export
 * @interface ClaimResponse
 */
export interface ClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCreditorInactive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCreditorClientSpecific: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isRepresentativeInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isRepresentativeClientSpecific: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    caseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    expectedLossPercent: number | null;
    /**
     * 
     * @type {Array<ClaimCollateralResponse>}
     * @memberof ClaimResponse
     */
    collaterals: Array<ClaimCollateralResponse>;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    claimEntirelyDisputed: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    recognizedAmount: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    srvRegistrationStatus: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    srvOrderNumber: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    notes: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCompleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    currentSaldo: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    disputedAmount: number;
    /**
     * 
     * @type {Array<BalanceEntryResponse>}
     * @memberof ClaimResponse
     */
    balanceEntries: Array<BalanceEntryResponse>;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    balanceListVersionUtc: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    lastChangedAtUtc?: Date | null;
}

/**
 * Check if a given object implements the ClaimResponse interface.
 */
export function instanceOfClaimResponse(value: object): value is ClaimResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('creditorId' in value) || value['creditorId'] === undefined) return false;
    if (!('creditorName' in value) || value['creditorName'] === undefined) return false;
    if (!('creditorAddress' in value) || value['creditorAddress'] === undefined) return false;
    if (!('isCreditorInactive' in value) || value['isCreditorInactive'] === undefined) return false;
    if (!('isCreditorClientSpecific' in value) || value['isCreditorClientSpecific'] === undefined) return false;
    if (!('representativeId' in value) || value['representativeId'] === undefined) return false;
    if (!('representativeName' in value) || value['representativeName'] === undefined) return false;
    if (!('representativeAddress' in value) || value['representativeAddress'] === undefined) return false;
    if (!('isRepresentativeInactive' in value) || value['isRepresentativeInactive'] === undefined) return false;
    if (!('isRepresentativeClientSpecific' in value) || value['isRepresentativeClientSpecific'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('legalBasis' in value) || value['legalBasis'] === undefined) return false;
    if (!('disputedStatus' in value) || value['disputedStatus'] === undefined) return false;
    if (!('collateralStatus' in value) || value['collateralStatus'] === undefined) return false;
    if (!('expectedLossPercent' in value) || value['expectedLossPercent'] === undefined) return false;
    if (!('collaterals' in value) || value['collaterals'] === undefined) return false;
    if (!('claimEntirelyDisputed' in value) || value['claimEntirelyDisputed'] === undefined) return false;
    if (!('recognizedAmount' in value) || value['recognizedAmount'] === undefined) return false;
    if (!('srvRegistrationStatus' in value) || value['srvRegistrationStatus'] === undefined) return false;
    if (!('srvOrderNumber' in value) || value['srvOrderNumber'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('currentSaldo' in value) || value['currentSaldo'] === undefined) return false;
    if (!('disputedAmount' in value) || value['disputedAmount'] === undefined) return false;
    if (!('balanceEntries' in value) || value['balanceEntries'] === undefined) return false;
    if (!('balanceListVersionUtc' in value) || value['balanceListVersionUtc'] === undefined) return false;
    return true;
}

export function ClaimResponseFromJSON(json: any): ClaimResponse {
    return ClaimResponseFromJSONTyped(json, false);
}

export function ClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientId': json['clientId'],
        'creditorId': json['creditorId'],
        'creditorName': json['creditorName'],
        'creditorAddress': json['creditorAddress'],
        'isCreditorInactive': json['isCreditorInactive'],
        'isCreditorClientSpecific': json['isCreditorClientSpecific'],
        'representativeId': json['representativeId'],
        'representativeName': json['representativeName'],
        'representativeAddress': json['representativeAddress'],
        'isRepresentativeInactive': json['isRepresentativeInactive'],
        'isRepresentativeClientSpecific': json['isRepresentativeClientSpecific'],
        'caseNumber': json['caseNumber'],
        'legalBasis': json['legalBasis'],
        'disputedStatus': json['disputedStatus'],
        'collateralStatus': json['collateralStatus'],
        'expectedLossPercent': json['expectedLossPercent'],
        'collaterals': ((json['collaterals'] as Array<any>).map(ClaimCollateralResponseFromJSON)),
        'claimEntirelyDisputed': json['claimEntirelyDisputed'],
        'recognizedAmount': json['recognizedAmount'],
        'srvRegistrationStatus': json['srvRegistrationStatus'],
        'srvOrderNumber': json['srvOrderNumber'],
        'notes': json['notes'],
        'isCompleted': json['isCompleted'],
        'currentSaldo': json['currentSaldo'],
        'disputedAmount': json['disputedAmount'],
        'balanceEntries': ((json['balanceEntries'] as Array<any>).map(BalanceEntryResponseFromJSON)),
        'balanceListVersionUtc': (json['balanceListVersionUtc'] == null ? null : new Date(json['balanceListVersionUtc'])),
        'lastChangedAtUtc': json['lastChangedAtUtc'] == null ? undefined : (new Date(json['lastChangedAtUtc'])),
    };
}

export function ClaimResponseToJSON(json: any): ClaimResponse {
    return ClaimResponseToJSONTyped(json, false);
}

export function ClaimResponseToJSONTyped(value?: ClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientId': value['clientId'],
        'creditorId': value['creditorId'],
        'creditorName': value['creditorName'],
        'creditorAddress': value['creditorAddress'],
        'isCreditorInactive': value['isCreditorInactive'],
        'isCreditorClientSpecific': value['isCreditorClientSpecific'],
        'representativeId': value['representativeId'],
        'representativeName': value['representativeName'],
        'representativeAddress': value['representativeAddress'],
        'isRepresentativeInactive': value['isRepresentativeInactive'],
        'isRepresentativeClientSpecific': value['isRepresentativeClientSpecific'],
        'caseNumber': value['caseNumber'],
        'legalBasis': value['legalBasis'],
        'disputedStatus': value['disputedStatus'],
        'collateralStatus': value['collateralStatus'],
        'expectedLossPercent': value['expectedLossPercent'],
        'collaterals': ((value['collaterals'] as Array<any>).map(ClaimCollateralResponseToJSON)),
        'claimEntirelyDisputed': value['claimEntirelyDisputed'],
        'recognizedAmount': value['recognizedAmount'],
        'srvRegistrationStatus': value['srvRegistrationStatus'],
        'srvOrderNumber': value['srvOrderNumber'],
        'notes': value['notes'],
        'isCompleted': value['isCompleted'],
        'currentSaldo': value['currentSaldo'],
        'disputedAmount': value['disputedAmount'],
        'balanceEntries': ((value['balanceEntries'] as Array<any>).map(BalanceEntryResponseToJSON)),
        'balanceListVersionUtc': value['balanceListVersionUtc'] == null ? value['balanceListVersionUtc'] : value['balanceListVersionUtc'].toISOString(),
        'lastChangedAtUtc': value['lastChangedAtUtc'] == null ? value['lastChangedAtUtc'] : value['lastChangedAtUtc'].toISOString(),
    };
}

